import ItemsAdmin from "./ItemsAdmin";
import { TextLogo } from "../components/site/Exchanges";

export const ExchangesAdmin = () => (
  <ItemsAdmin name="exchanges" title="Our Exchanges" sub="Exchange cards on the homepage — logo, website, bonus and demo login"
    imageKey="logo" imageLabel="Logo (optional)" preview={(x) => <TextLogo name={x.name || "LOGO"} />}
    blank={{ name: "", website: "", bonus: "5% Welcome Bonus", commission: "10% Loss Commission", demo_user: "", demo_pass: "", logo: "", order: 0, active: true }}
    fields={[["name", "Name"], ["website", "Website"], ["bonus", "Bonus text"], ["commission", "Commission text"], ["demo_user", "Demo user ID"], ["demo_pass", "Demo password"]]} />
);

export const ProofsAdmin = () => (
  <ItemsAdmin name="proofs" title="Withdrawal Proofs" sub="Payout screenshots shown on the homepage"
    imageKey="image" imageLabel="Screenshot" preview={() => <div className="grid h-full place-items-center text-xs text-zinc-600">No image</div>}
    blank={{ image: "", caption: "", amount: "", order: 0, active: true }}
    fields={[["amount", "Amount (e.g. ₹48,500)"], ["caption", "Caption"]]} />
);
